<template>
  <div class="top">
    <div class="home-banner" @click="pay">
      <div class="pc-banner">
        <img
          :src="require(`@/assets/images/${languages}/home/pc/banner.jpg`)"
          alt="banner"
        />
        <div class="pc-download-box">
          <a class="pc-icon" href="https://zenifun.com/" target="_blank"></a>
          <a
            class="pc-google"
            href="https://play.google.com/store/apps/details?id=com.hw.yybs"
            target="_blank"
          ></a>
          <a
            class="pc-app"
            href="https://apps.apple.com/app/id6482995168"
            target="_blank"
          ></a>
          <a
            class="pc-apk"
            href="https://drive.google.com/file/d/1zOojWA9SxAuoRB0KExPdSOJ7h45Qv8h9/view?usp=sharing"
            target="_blank"
          ></a>
        </div>
      </div>
      <div class="mobile-banner">
        <img
          :src="require(`@/assets/images/${languages}/home/mobile/banner.jpg`)"
          alt="banner"
        />
        <div class="mobile-download-box">
          <a
            class="mobile-google"
            href="https://play.google.com/store/apps/details?id=com.hw.yybs"
            target="_blank"
          ></a>
          <a
            class="mobile-app"
            href="https://apps.apple.com/app/id6482995168"
            target="_blank"
          ></a>
          <a
            class="mobile-apk"
            href="https://drive.google.com/file/d/1zOojWA9SxAuoRB0KExPdSOJ7h45Qv8h9/view?usp=sharing"
            target="_blank"
          ></a>
        </div>
      </div>
    </div>
    <div class="pc-role-box">
      <div class="role">
        <img
          class="role-bg"
          :src="require(`@/assets/images/${languages}/home/pc/role/d1-bj.jpg`)"
          alt="bg"
        />
        <div class="role-title">
          <img
            :src="
              require(`@/assets/images/${languages}/home/pc/role/big-title.png`)
            "
            alt=""
          />
        </div>
        <!-- 左侧文字 -->
        <div class="role-side-text">
          <div v-for="item in sideTextList" :key="item.imgName">
            <img
              v-show="item.imgName === sideTextActive"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 介绍背景 -->
        <div class="introduce-bg">
          <div v-for="item in introduceBgList" :key="item.imgName">
            <img
              v-show="item.imgName === introduceBgActive"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 人物 -->
        <div class="character">
          <div v-for="item in characterList" :key="item.imgName">
            <img
              v-show="item.imgName === characterActive"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 描述介绍 -->
        <div class="introduce">
          <div v-for="(item, index) in introduceList" :key="item.imgName">
            <img
              v-show="item.imgName === introduceActive"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
              "
              alt=""
            />
            <div
              class="audio-box"
              :class="`audio-box-${index + 1}`"
              v-if="item.imgName === introduceActive"
              @click="handlePlayAudio(index, 'pc')"
            >
              <img
                class="voice-cion"
                :src="
                  require(`@/assets/images/${languages}/home/pc/role/voice-icon.png`)
                "
                alt=""
              />
              <img
                class="voice"
                :src="
                  require(`@/assets/images/${languages}/home/pc/role/voice.gif`)
                "
                alt=""
              />
            </div>
            <audio
              ref="audio"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/video/${
                  index + 1
                }.wav`)
              "
              :key="index"
            ></audio>
          </div>
        </div>
        <!-- 人物头像选项 -->
        <div class="role-nav">
          <div class="nav-item">
            <ul>
              <li
                v-for="(item, index) in roleNav"
                :key="item.imgName"
                @click="handRoleNav(item, index)"
              >
                <img
                  v-if="item.imgName === roleNavActive"
                  :src="
                    require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
                  "
                  alt=""
                />
                <img
                  v-else
                  :src="
                    require(`@/assets/images/${languages}/home/pc/role/${item.imgName2}.png`)
                  "
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-role-box">
      <div class="role">
        <img
          class="role-bg"
          :src="
            require(`@/assets/images/${languages}/home/mobile/role/d1-bj.png`)
          "
          alt="bg"
        />
        <div class="role-title">
          <img
            :src="
              require(`@/assets/images/${languages}/home/mobile/role/big-title.png`)
            "
            alt=""
          />
        </div>
        <!-- 左侧文字 -->
        <div class="role-side-text">
          <div v-for="item in sideTextList" :key="item.imgName">
            <img
              v-show="item.imgName === sideTextActive"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 介绍背景 -->
        <div class="introduce-bg">
          <div v-for="item in introduceBgList" :key="item.imgName">
            <img
              v-show="item.imgName === introduceBgActive"
              :src="
                require(`@/assets/images/${languages}/home/mobile/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 人物 -->
        <div class="character">
          <div v-for="item in characterList" :key="item.imgName">
            <img
              v-show="item.imgName === characterActive"
              :src="
                require(`@/assets/images/${languages}/home/mobile/role/${item.imgName}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <!-- 描述介绍 -->
        <div class="introduce">
          <div v-for="(item, index) in MintroduceList" :key="item.name">
            <div
              :class="`intr-${index + 1}`"
              v-show="item.name === MintroduceActive"
            >
              <img
                class="name"
                :src="
                  require(`@/assets/images/${languages}/home/mobile/role/${item.name}.png`)
                "
                alt=""
              />
              <img
                class="text"
                :src="
                  require(`@/assets/images/${languages}/home/mobile/role/${item.text}.png`)
                "
                alt=""
              />
              <img
                class="cv"
                :src="
                  require(`@/assets/images/${languages}/home/mobile/role/${item.cv}.png`)
                "
                @click="handlePlayAudio(index, 'mobile')"
                alt=""
              />
              <img
                class="xqbut"
                :src="
                  require(`@/assets/images/${languages}/home/mobile/role/xqbut.png`)
                "
                @click="handleIsPopup(index, 'mobile')"
                alt=""
              />
            </div>
            <audio
              v-show="item.name === MintroduceActive"
              ref="audio2"
              :src="
                require(`@/assets/images/${languages}/home/pc/role/video/${
                  index + 1
                }.wav`)
              "
              :key="index"
            ></audio>
          </div>
        </div>
        <!-- 人物头像选项 -->
        <div class="role-nav">
          <div class="nav-item">
            <ul>
              <li
                v-for="(item, index) in roleNav"
                :key="item.imgName"
                @click="handRoleNav(item, index)"
              >
                <img
                  v-if="item.imgName === roleNavActive"
                  :src="
                    require(`@/assets/images/${languages}/home/mobile/role/${item.imgName}.png`)
                  "
                  alt=""
                />
                <img
                  v-else
                  :src="
                    require(`@/assets/images/${languages}/home/mobile/role/${item.imgName2}.png`)
                  "
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>

        <!-- 弹窗 -->
        <div v-for="(item, index) in MintroduceList" :key="item.name">
          <div
            class="alert-bg"
            v-show="item.name === MintroduceActive && isPopup"
          >
            <div class="alert-main-box">
              <div class="alert-main">
                <img
                  :src="
                    require(`@/assets/images/${languages}/home/mobile/role/x.png`)
                  "
                  alt=""
                  class="close"
                  @click="handleIsPopup(index, 'mobile')"
                />
                <img
                  :src="
                    require(`@/assets/images/${languages}/home/mobile/role/${item.popup}.png`)
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      resDatas: "",
      urls: "",
      show: false,
      roleNavActive: "d7-1",
      roleNav: [
        {
          imgName: "d7-1",
          imgName2: "d7-2",
        },
        {
          imgName: "d8-1",
          imgName2: "d8-2",
        },
        {
          imgName: "d9-1",
          imgName2: "d9-2",
        },
        {
          imgName: "d10-1",
          imgName2: "d10-2",
        },
        {
          imgName: "d11-1",
          imgName2: "d11-2",
        },
      ],
      sideTextActive: "d2-Yuusuke",
      sideTextList: [
        {
          imgName: "d2-Yuusuke",
        },
        {
          imgName: "d3-Kazuma",
        },
        {
          imgName: "d5-Hiei",
        },
        {
          imgName: "d6-Kurama",
        },
        {
          imgName: "d4-Toguro",
        },
      ],
      introduceActive: "d2-3xx",
      introduceList: [
        {
          imgName: "d2-3xx",
        },
        {
          imgName: "d3-3xx",
        },
        {
          imgName: "d5-3xx",
        },
        {
          imgName: "d6-3xx",
        },
        {
          imgName: "d4-3xx",
        },
      ],
      characterActive: "d2-2rw",
      characterList: [
        {
          imgName: "d2-2rw",
        },
        {
          imgName: "d3-2rw",
        },
        {
          imgName: "d5-2rw",
        },
        {
          imgName: "d6-2rw",
        },
        {
          imgName: "d4-2rw",
        },
      ],
      introduceBgActive: "d2-1sk",
      introduceBgList: [
        {
          imgName: "d2-1sk",
        },
        {
          imgName: "d3-1sk",
        },
        {
          imgName: "d5-1sk",
        },
        {
          imgName: "d6-1sk",
        },
        {
          imgName: "d4-1sk",
        },
      ],
      MintroduceActive: "r1-name",
      MintroduceList: [
        {
          name: "r1-name",
          text: "r1-text",
          cv: "r1-cv",
          popup: "pop-up-1",
        },
        {
          name: "r2-name",
          text: "r2-text",
          cv: "r2-cv",
          popup: "pop-up-2",
        },
        {
          name: "r3-name",
          text: "r3-text",
          cv: "r3-cv",
          popup: "pop-up-3",
        },
        {
          name: "r4-name",
          text: "r4-text",
          cv: "r4-cv",
          popup: "pop-up-4",
        },
        {
          name: "r5-name",
          text: "r5-text",
          cv: "r5-cv",
          popup: "pop-up-5",
        },
      ],
      isPopup: false,
    };
  },
  computed: {
    ...mapState(["languages", "languagesData"]), // 在这里引入你需要的state值
  },
  created() {
    // console.log(this.languages);
    // console.log(`@/assets/images/${this.languages}`);
    // if (this.isGoogleChrome()) {
    //   console.log("用户正在使用谷歌浏览器");
    // } else {
    //   console.log("用户不是在使用谷歌浏览器");
    // }
  },
  mounted() {
    this.$store.state.highlight = "index";
  },
  methods: {
    // isGoogleChrome() {
    //   const userAgent = navigator.userAgent;
    //   console.log("User Agent: ", userAgent); // 打印用户代理字符串
    //   return /Chrome/.test(userAgent) && !/Edg|OPR/.test(userAgent); // 排除 Edge 和 Opera
    // },
    pay() {
      this.urls =
        'https://openapi.alipay.com/gateway.do?alipay_sdk=alipay-sdk-php-20161101&app_id=2021004111692168&biz_content={"productCode":"QUICK_WAP_PAY","body":"充值共25.00元","subject":"末世部落","out_trade_no":"202404161742391035047914469003","total_amount":"25.00","timeout_express":"1m"}&charset=UTF-8&format=json&method=alipay.trade.wap.pay&notify_url=https://sdk.ihulai.com/PayNotify/notifyAlipayConfig&return_url=https://sdk.ihulai.com/WebApp/notify&sign_type=RSA2&timestamp=2024-04-16 17:47:34&version=1.0&sign=dLX2A6RCmD4bj1kpSH%2B1U5DepM%2FTOvCzepaosOp0BwkZn1XEcA6xSGqNTEg%2BABcHJSMSivETAZKdO2hLEWY4MwD%2Bzhw5nLe%2FQeOocUw2UKkUcKTGNm5qEPThNALX%2BvgyucILOlAEWjIxIvJqAkUnYPRnckqD6CT1W21%2BLLlBYA9K9TZSU5PpYb1R1vWXWLzsERIi%2FB8sVhkhllAq7LgBTN7U4VMUYVyDiGAZ6hTp36udJOKl1oQO3xF1%2BkFy5ZWh3L7R2REWVv6SE%2FbrPgm0ZISsg2xwe65zALDII%2BfzLE3Uw6VPW500p8Q7C7o8PklJzEpsbfY9UXhxsRiTD0TzmA%3D%3D';
      this.show = true;
    },
    /* 点击切换角色介绍 */
    handRoleNav(info, index) {
      if (this.roleNavActive === info.imgName) {
        return false;
      }
      this.roleNavActive = info.imgName;
      this.introduceActive = this.introduceList[index].imgName;
      this.characterActive = this.characterList[index].imgName;
      this.introduceBgActive = this.introduceBgList[index].imgName;
      this.sideTextActive = this.sideTextList[index].imgName;
      this.MintroduceActive = this.MintroduceList[index].name;
    },
    /* 播放角色音频 */
    handlePlayAudio(index, clientType) {
      this.$nextTick(() => {
        // console.log(index, this.$refs.audio[index]);
        // 获取对应的 audio 元素并播放
        let audioElement =
          clientType === "pc"
            ? this.$refs.audio[index]
            : this.$refs.audio2[index];

        if (audioElement) {
          audioElement.pause();
          audioElement.currentTime = 0; // 从头开始播放
          audioElement.play().catch((error) => {
            console.error("播放音频失败:");
          });
        }
      });
    },
    /* 打开mobile角色信息 */
    handleIsPopup(index, clientType) {
      this.isPopup = !this.isPopup;
    },
  },
};
</script>

<style scoped>
.top {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
  background: black;
}

.pc-banner {
  margin-top: 84px;
  position: relative;
}
.pc-download-box {
  position: absolute;
  width: 711px;
  height: 156px;
  z-index: 10;
  top: 80%;
  left: 9%;
}
.pc-icon {
  display: block;
  position: absolute;
  width: 144px;
  height: 144px;
  top: 0%;
  left: 0%;
}
.pc-google {
  display: block;
  position: absolute;
  width: 173px;
  height: 52px;
  top: 59%;
  left: 21%;
}
.pc-app {
  display: block;
  position: absolute;
  width: 173px;
  height: 52px;
  top: 59%;
  left: 46%;
}
.pc-apk {
  display: block;
  position: absolute;
  width: 173px;
  height: 52px;
  top: 59%;
  left: 72%;
}
.home-banner img {
  display: block;
  width: 100%;
}
.mobile-banner {
  position: relative;
}
.mobile-banner img {
  display: block;
  width: 100%;
  margin-top: 84px;
}
.mobile-download-box {
  position: absolute;
  width: 665px;
  height: 63px;
  z-index: 10;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 17.3%;
  display: flex;
  justify-content: space-between;
}
.mobile-google {
  display: block;
  width: 216px;
  height: 63px;
}
.mobile-app {
  display: block;
  width: 216px;
  height: 63px;
}
.mobile-apk {
  display: block;
  width: 216px;
  height: 63px;
}
.pc-role-box {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.pc-role-box .role-bg {
  display: block;
  width: 100%;
}

.pc-role-box .role-side-text {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  top: 0;
  left: 0;
  z-index: 1;
}

.pc-role-box .role-side-text img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.pc-role-box .role-title {
  width: 683px;
  height: 110px;
  position: absolute;
  margin: 0 auto;
  top: 37px;
  left: 0;
  right: 0;
  z-index: 2;
}

.pc-role-box .role-title img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.pc-role-box .introduce-bg {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  bottom: 328px;
  right: 0;
  z-index: 1;
}

.pc-role-box .introduce-bg img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.pc-role-box .introduce {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  left: 849px;
  top: 229px;
  z-index: 1;
}

.pc-role-box .introduce img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.pc-role-box .audio-box {
  max-width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 86px;
  right: 55px;
  z-index: 1;
}

.pc-role-box .audio-box.audio-box-3 {
  right: 282px;
}

.pc-role-box .audio-box.audio-box-4 {
  right: 282px;
}

.pc-role-box .audio-box .voice-cion {
  display: block;
  max-width: 100%;
  width: 24px;
  margin-right: 8px;
}

.pc-role-box .audio-box .voice {
  display: block;
  max-width: 100%;
  width: 178px;
}

.pc-role-box .role-nav {
  position: absolute;
  right: 324px;
  bottom: 102px;
  z-index: 1;
}

.pc-role-box .role-nav ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pc-role-box .role-nav img {
  width: 164px;
  height: 214px;
  cursor: pointer;
}

.pc-role-box .character {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.pc-role-box .character img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.mobile-role-box {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.mobile-role-box .role-bg {
  display: block;
  width: 100%;
}

.mobile-role-box .role-side-text {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  top: 155px;
  right: 0;
  z-index: 1;
}

.mobile-role-box .role-side-text img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.mobile-role-box .role-title {
  width: 304px;
  height: 86px;
  position: absolute;
  margin: 0 auto;
  top: 51px;
  left: 33px;
  z-index: 2;
}

.mobile-role-box .role-title img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.mobile-role-box .introduce-bg {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  top: 249px;
  left: 48px;
  z-index: 1;
}

.mobile-role-box .introduce-bg img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.mobile-role-box .introduce {
  max-width: 100%;
  position: absolute;
  margin: 0 auto;
  right: 0;
  left: 48px;
  top: 50%;
  z-index: 1;
}

.mobile-role-box .introduce img {
  display: block;
  width: 100%;
}

.mobile-role-box .introduce .intr-1 img.name {
  width: 279px;
  height: 65px;
}
.mobile-role-box .introduce .intr-2 img.name {
  width: 279px;
  height: 65px;
}
.mobile-role-box .introduce .intr-3 img.name {
  width: 210px;
  height: 65px;
}
.mobile-role-box .introduce .intr-4 img.name {
  width: 210px;
  height: 65px;
}
.mobile-role-box .introduce .intr-5 img.name {
  width: 269px;
  height: 65px;
}

.mobile-role-box .introduce .intr-1 img.text {
  width: 448px;
  height: 81px;
  margin-top: 39px;
}
.mobile-role-box .introduce .intr-2 img.text {
  width: 296px;
  height: 81px;
  margin-top: 39px;
}
.mobile-role-box .introduce .intr-3 img.text {
  width: 378px;
  height: 37px;
  margin-top: 39px;
}
.mobile-role-box .introduce .intr-4 img.text {
  width: 443px;
  height: 81px;
  margin-top: 39px;
}
.mobile-role-box .introduce .intr-5 img.text {
  width: 338px;
  height: 81px;
  margin-top: 39px;
}

.mobile-role-box .introduce .intr-1 img.cv {
  width: 259px;
  height: 48px;
  cursor: pointer;
  position: absolute;
  right: 129px;
  top: 243px;
  z-index: 1;
}
.mobile-role-box .introduce .intr-2 img.cv {
  width: 241px;
  height: 48px;
  cursor: pointer;
  position: absolute;
  right: 129px;
  top: 243px;
  z-index: 1;
}
.mobile-role-box .introduce .intr-3 img.cv {
  width: 249px;
  height: 48px;
  cursor: pointer;
  position: absolute;
  right: 129px;
  top: 243px;
  z-index: 1;
}
.mobile-role-box .introduce .intr-4 img.cv {
  width: 226px;
  height: 48px;
  cursor: pointer;
  position: absolute;
  right: 129px;
  top: 243px;
  z-index: 1;
}
.mobile-role-box .introduce .intr-5 img.cv {
  width: 249px;
  height: 48px;
  cursor: pointer;
  position: absolute;
  right: 129px;
  top: 243px;
  z-index: 1;
}

.mobile-role-box .introduce .intr-1 img.xqbut,
.mobile-role-box .introduce .intr-2 img.xqbut,
.mobile-role-box .introduce .intr-3 img.xqbut,
.mobile-role-box .introduce .intr-4 img.xqbut,
.mobile-role-box .introduce .intr-5 img.xqbut {
  width: 275px;
  height: 69px;
  cursor: pointer;
  position: absolute;
  right: 49px;
  top: 314px;
  z-index: 1;
}

.mobile-role-box .role-nav {
  margin: 0 auto;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 78px;
  z-index: 1;
}

.mobile-role-box .role-nav .nav-item {
  display: flex;
  align-items: center;
  margin: 0 auto;
  text-align: center;
}

.mobile-role-box .role-nav ul {
  margin: 0 auto;
  display: flex;
  align-items: center;
  text-align: center;
}

.mobile-role-box .role-nav img {
  width: 143px;
  height: 221px;
  cursor: pointer;
}

.mobile-role-box .character {
  max-width: 750px;
  width: 100%;
  position: absolute;
  margin: 0 auto;
  left: 0;
  top: 45px;
  z-index: 1;
}

.mobile-role-box .character img {
  display: block;
  max-width: 100%;
  width: 100%;
}

.alert-bg {
  position: fixed;
  max-width: 750px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 100;
  width: 100%;
  height: 100%;
}

.alert-main-box {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.alert-main {
  margin: 0 auto;
  max-width: 750px;
  position: relative;
  text-align: center;
}

.close {
  position: absolute;
  top: 320px;
  right: 50px;
  cursor: pointer;
}

/* .swiper {
  width: 100%;
  height: 100%;
  position: relative;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-slide {
  width: 1042px;
  height: 574px;
  opacity: 0.5;
}
.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide-active {
  opacity: 1;
}
.top-list2 {
  max-width: 1000px;
  margin: auto;
  padding: 114px 0 230px;
}
.top-list2 .title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
} */
/* .product-main {
}
.product-main ul {
} */
/* .product-main ul::after {
  content: "";
  clear: both;
  display: block;
}
.product-main li {
  margin-bottom: 3%;
}

.list-item {
  position: relative;
  background-color: white;
  overflow: hidden;
  border-radius: 5px;
  display: block;
}
.list-banner {
  position: relative;
  overflow: hidden;
}
.list-banner img {
  width: 100%;
  height: 100%;
  transition: all 0.3s;
}
.banner-title {
  position: absolute;
  height: 0;
  width: 100%;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  transition: all 0.3s;
  cursor: pointer;
}
.banner-title a {
  display: block;
  color: white;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
}
.game-icon {
  display: inline-block;
  width: 80px;
  position: relative;
  left: 50%;
  margin: auto;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
  border-radius: 8px;
}
.text-item {
  height: 162px;
  position: relative;
}
.text-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  left: 0;
}
.text-box h3 {
  font-size: 38px;
  position: relative;
  display: block;
  transition: all 0.3s;
  text-align: center;
}
.text-box p {
  font-size: 28px;
  position: relative;
  display: block;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  text-align: center;
  color: #155da6;
}

.home-banner {
  width: 100%;
}
.home-banner img {
  display: block;
  width: 100%;
}
@media screen and (max-width: 1000px) {
  .swiper-slide {
    width: 100%;
    height: auto;
  }
  .product-main li {
    width: 100%;
    padding: 0 3%;
    box-sizing: border-box;
  }
  .top-list2 {
    padding: 10% 0;
  }
  .text-item {
    height: 120px;
  }
  .text-box h3 {
    font-size: 24px;
  }
  .text-box p {
    font-size: 20px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/top.vue